"use client";

import dynamic from "next/dynamic";
import React from "react";
import { Emdash } from "../Punctuation/Emdash";
import { isValidDateString } from "~/utils/isValidDateString";

const TimeAgoInternal = dynamic(
    () =>
        import("./TimeAgoInternals").then((mod) => ({
            default: mod.TimeAgoInternal,
        })),
    { ssr: false },
);

// // // //

export function TimeAgoDisplay(props: { value: undefined | null | string }) {
    if (!props.value) {
        return <Emdash />;
    }

    if (!isValidDateString(props.value)) {
        return <Emdash />;
    }

    const date = new Date(props.value);
    return <TimeAgoInternal value={date} />;
}
